// extracted by mini-css-extract-plugin
export default {"container":"narrow_container__aZ1-0","inner":"narrow_inner__A+HRR","background":"narrow_background__8Ohwc","overlay":"narrow_overlay__jeqIq","content":"narrow_content__55LJ7"};